import { render, staticRenderFns } from "./CourseHour.vue?vue&type=template&id=25955052&scoped=true"
import script from "./CourseHour.vue?vue&type=script&lang=js"
export * from "./CourseHour.vue?vue&type=script&lang=js"
import style0 from "./CourseHour.vue?vue&type=style&index=0&id=25955052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25955052",
  null
  
)

export default component.exports